export const MANAGER_ROLE = "Responsable";
export const DRIVER_ROLES = "Chauffeur";
export const ROLES = [MANAGER_ROLE];
